import type { DomainSchema, PdfCardDef } from '../types';
import { dateRange, esc } from '../pdf-helpers';

export const ORGANIZATIONS = {
  priority: true,
  cardTitle: '{organizationName}',
  fields: {
    organizationName: { type: 'text', label: 'Organization' },
    role: { type: 'text' },
    description: { type: 'textarea' },
    startDate: { type: 'date', label: 'Start Date' },
    endDate: { type: 'date', label: 'End Date' },
    url: { type: 'text', label: 'URL' },
  },
  layout: [
    [{ field: 'role' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
  editLayout: [
    [{ field: 'organizationName' }],
    [{ field: 'role' }],
    [
      { field: 'startDate', width: 50 },
      { field: 'endDate', width: 50 },
    ],
    [{ field: 'url' }],
    [{ field: 'description' }],
  ],
} satisfies DomainSchema;

export const OrganizationsPdfCard: PdfCardDef = {
  styles: `
    .org-item { padding: 0.75rem 0; border-bottom: 1px solid var(--line); }
    .org-item:first-child { padding-top: 0; }
    .org-item:last-child { border-bottom: none; padding-bottom: 0; }
    .org-name { font-size: 13.5px; font-weight: 700; }
    .org-role { font-size: 12px; color: var(--blue-gray); font-weight: 400; margin-top: 2px; }
    .org-meta { font-size: 11px; color: var(--muted); margin-top: 3px; }
  `,
  render(records) {
    return records
      .map(r => {
        const dr = dateRange(r['startDate'], r['endDate'], false);
        return `
          <div class="org-item">
            <div class="org-name">${esc(r['organizationName'])}</div>
            ${r['role'] ? `<div class="org-role">${esc(r['role'])}</div>` : ''}
            ${dr ? `<div class="org-meta">${dr}</div>` : ''}
            ${r['description'] ? `<div class="bp-note">${esc(r['description'])}</div>` : ''}
          </div>`;
      })
      .join('');
  },
};
